import { render, staticRenderFns } from "./HeatersSensorInput.vue?vue&type=template&id=3513ba26&"
import script from "./HeatersSensorInput.vue?vue&type=script&lang=js&"
export * from "./HeatersSensorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports